var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZap = function SvgZap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "zap_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h48v48H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#zap_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.097 2.124a1.5 1.5 0 0 1 .891 1.562L25.2 18H41.5a1.5 1.5 0 0 1 1.152 2.46l-20 24a1.5 1.5 0 0 1-2.64-1.146L21.8 29H5.5a1.5 1.5 0 0 1-1.152-2.46l20-24a1.5 1.5 0 0 1 1.75-.416ZM8.703 26H23.5a1.5 1.5 0 0 1 1.488 1.686L23.623 38.61 38.297 21H23.5a1.5 1.5 0 0 1-1.488-1.686l1.365-10.923L8.703 26Z",
    fill: "#004152"
  }))));
};
export default SvgZap;